import { openNotification } from "../../../globals/Components/Notification/Notification";
import { serverMessages, serverMessagesNoOpenNotification } from "../../serverMessages";
import { setErrorMessageResponse, setMessageResponse, toggleErrorIndicator, toggleLoadingIndicator } from "../../system/actions";
import { MessageResponse } from "../../system/types";
import { AppThunk } from "../../thunks";
import { setOfertas } from './actions';
import {PostOfertaAPI, updateOfertaAPI,getAllOfertasAPI,getOfertaByIdAPI,deleteOfertaAPI,getAllOfertasActivasAPI} from './restCallOfertas'

export const postOfertas = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await PostOfertaAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso", "Proceso ejcutado correctamente")
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const updateOferta= (value:object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await updateOfertaAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false
    }
    else if (responseData.StatusCode === 200) {      
        dispatch(setMessageResponse(null));       
        dispatch(toggleLoadingIndicator(false));
        openNotification("","Oferta actualizada"); 
        return true
    }
    dispatch(toggleLoadingIndicator(false));
};
export const deleteOferta= (id:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteOfertaAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false
    }
    else if (responseData.StatusCode === 200) {      
        dispatch(setMessageResponse(null));       
        dispatch(toggleLoadingIndicator(false));
        openNotification("","Oferta eliminada"); 
        return true
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getAllOfertasActivas = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllOfertasActivasAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(setOfertas(responseData.Response)); 
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getAllOfertas = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllOfertasAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(setOfertas(responseData.Response)); 
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOfertaById = (id: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOfertaByIdAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null)); 
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


// export const getProducts = (categoria?: string, nombre?: string): any => async (dispatch: any) => {
//     dispatch(toggleLoadingIndicator(true));

//     const responseData = await GetProductsAPI(categoria, nombre);

//     if (responseData.Error !== null) {
//         dispatch(setMessageResponse(serverMessages(responseData)));
//     } else if (responseData.StatusCode === 200) {
//         dispatch(setProducts(responseData.Response)); // ← limpio
//     }

//     dispatch(toggleLoadingIndicator(false));
// };

